import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initErrorReporter } from "./lib/errorReporter";

initErrorReporter();

// Remove splash screen once React is ready
const splash = document.getElementById('splash-screen');
if (splash) {
  splash.style.transition = 'opacity 0.3s ease';
  splash.style.opacity = '0';
  setTimeout(() => splash.remove(), 300);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
